/**
 * 상수 정의
 */

// API 관련 상수
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/api';

export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Lumin Art Admin';

// 권한 레벨
export const ROLE_SUPER_ADMIN = 'super_admin';
export const ROLE_ADMIN = 'admin';
export const ROLE_SITE_MANAGER = 'site_manager';
export const ROLE_VIEWER = 'viewer';

// 로컬 스토리지 키
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'admin_access_token',
  USER: 'admin_user',
} as const;

// 반응형 브레이크포인트
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
} as const;

